import { api } from 'api'

export const createUserApi = payload => {
  return new Promise(resolve => {
    const response = api.post({ endpoint: '/users', body: payload })
    resolve(response)
  })
}
